var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "25",
        height: "19",
        viewBox: "0 0 25 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M11.8929 14.2857H11.1429V13H9.85714V12.25L11.4107 10.6964L13.4464 12.7321L11.8929 14.2857ZM17.7857 4.64286C17.9063 4.76339 17.8929 4.96428\n  17.7723 5.08482L13.0848 9.77232C12.9643 9.89286 12.7634 9.90625 12.6429 9.78571C12.5223 9.66518 12.5357 9.46429 12.6562 9.34375L17.3438 4.65625C17.4643\n   4.53571 17.6652 4.52232 17.7857 4.64286ZM18.8571 12.5982C18.8571 12.4241 18.75 12.2768 18.5893 12.2098C18.4286 12.1429 18.2545 12.1696 18.1205 12.3036L17.2634\n   13.1607C17.183 13.2411 17.1429 13.3482 17.1429 13.4554V15.1429C17.1429 16.3214 16.1786 17.2857 15 17.2857H3.85714C2.67857 17.2857 1.71429 16.3214 1.71429\n   15.1429V4C1.71429 2.82143 2.67857 1.85714 3.85714 1.85714H15C15.2009 1.85714 15.4018 1.88393 15.6027 1.9375C15.75 1.99107 15.9107 1.95089 16.0313 1.83036L16.6875\n   1.17411C16.7946 1.06696 16.8348 0.933035 16.808 0.785714C16.7813 0.651785 16.6875 0.531249 16.567 0.477677C16.0714 0.249999 15.5357 0.142856 15 0.142856H3.85714C1.72768\n   0.142856 0 1.87053 0 4V15.1429C0 17.2723 1.72768 19 3.85714 19H15C17.1295 19 18.8571 17.2723 18.8571 15.1429V12.5982ZM17.5714 2.71428L8.57143 11.7143V15.5714H12.4286L21.4286\n   6.57143L17.5714 2.71428ZM23.5179 4.48214C24.0134 3.98661 24.0134 3.15625 23.5179 2.66071L21.4821 0.624999C20.9866 0.129464 20.1563 0.129464 19.6607 0.624999L18.4286 1.85714L22.2857\n   5.71428L23.5179 4.48214Z",
          fill: "#333333",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }